export default __webpack_public_path__ + "static/header-6f23b1e013d0e71d636706102dab294b.jpg";